<template>
  <div class="feedback">
    <img
      class="top_img"
      src="https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/shopping/feedback/feedback_img.png"
      alt="img"
    />
    <div class="content">
      <h2 class="title">宁东工业超市 诉求反馈</h2>
      <el-form
        :model="dataForm"
        ref="dataForm"
        @keyup.enter.native="onSubmit()"
        label-position="top"
      >
        <el-form-item label="诉求类型">
          <el-button
            v-for="item in appealTypeOptions"
            :key="item.value"
            type="primary"
            :plain="!dataForm.appealType.includes(item.value)"
            @click="onSetAppealType(item)"
            >{{ item.value }}</el-button
          >
        </el-form-item>
        <el-form-item label="诉求说明">
          <el-input
            type="textarea"
            v-model="dataForm.desc"
            rows="5"
            maxlength="200"
            show-word-limit
            placeholder="请输入诉求说明"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-for="item in typeList"
          :key="item.value"
          :label="item.value"
        >
          <el-input
            type="textarea"
            v-model="appealDict[item.value]"
            rows="2"
            maxlength="200"
            :placeholder="`请输入${item.value}`"
          ></el-input>
        </el-form-item>
        <div class="flex">
          <el-form-item label="销售合同" class="flex-1 mr-16">
            <el-input
              type="textarea"
              v-model="dataForm.contract"
              rows="2"
              maxlength="200"
              placeholder="请输入销售合同"
            ></el-input>
          </el-form-item>
          <el-form-item label="物料" class="flex-1">
            <el-input
              type="textarea"
              v-model="dataForm.material"
              rows="2"
              maxlength="200"
              placeholder="请输入物料"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="center">
        <el-button class="submitBtn" type="primary" @click="onSubmit"
          >提交</el-button
        >
      </div>
    </div>
    <div class="mask center" v-if="isShowMask">
      <div class="tip">
        <i class="el-icon-success icon"></i>
        <div class="tip_text">
          您的诉求已收到，单据编号{{ ordeCode }}，我们将在2个工作日内联系您。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      appealTypeOptions: [
        {
          value: '售前支持',
          children: [
            {
              value: '销售服务'
            },
            {
              value: '产品解决方案'
            }
          ]
        },
        {
          value: '商品维度',
          children: [
            {
              value: '报价及时性'
            },
            {
              value: '商品质量'
            }
          ]
        },
        {
          value: '发货维度',
          children: [
            {
              value: '交付及时性'
            },
            {
              value: '产品包装'
            }
          ]
        },
        {
          value: '售后服务',
          children: [
            {
              value: '售后处理及时性'
            },
            {
              value: '售后服务态度'
            }
          ]
        },
        {
          value: '协作配合',
          children: [
            {
              value: '协作主动性'
            },
            {
              value: '协作态度'
            }
          ]
        },
        {
          value: '责任感',
          children: [
            {
              value: '承诺完成情况'
            },
            {
              value: '主动意识'
            }
          ]
        }
      ],
      dataForm: {
        appealType: [],
        desc: '',
        contract: '',
        material: ''
      },
      appealDict: {},
      isShowMask: false,
      ordeCode: ''
    }
  },
  computed: {
    typeList () {
      return this.dataForm.appealType
        .map((i) => {
          const item = this.appealTypeOptions.find((j) => j.value === i)
          if (item) {
            return item.children.map((c) => {
              return {
                parent: item.value,
                value: c.value
              }
            })
          } else {
            return []
          }
        })
        .flat(1)
    }
  },
  methods: {
    onSetAppealType (res) {
      const index = this.dataForm.appealType.findIndex((i) => {
        return i === res.value
      })
      if (index < 0) {
        this.dataForm.appealType.push(res.value)
      } else {
        this.dataForm.appealType.splice(index, 1);
        (res.children || []).forEach((i) => {
          Reflect.deleteProperty(this.appealDict, i.value)
        })
      }
    },
    onSubmit () {
      const { desc, contract, material } = this.dataForm
      const hasVal = Object.values(this.appealDict).filter((i) => !!i).length
      if (!desc && !contract && !material && !hasVal) {
        this.$message.warning('请至少填写一项')
        return
      }

      const optionsStr = Object.keys(this.appealDict)
        .filter((i) => {
          return this.appealDict[i]
        })
        .map((i) => {
          const fitem = this.typeList.find((t) => {
            return t.value === i
          })
          // "其他"特殊处理
          const label =
            fitem.parent === '其他' ? '其他' : `${fitem.parent}-${fitem.value}`
          return `<p>${label}:${this.appealDict[i]};</p><br/>`
        })
        .join('')

      const str = `${desc ? '<p>诉求说明:' + desc + ';</p><br/>' : ''}
      ${optionsStr}
      ${contract ? '<p>销售合同:' + contract + ';</p><br/>' : ''}
      ${material ? '<p>物料:' + material + ';</p><br/>' : ''}`
      console.log(str)

      this.$http
        .post(`/front/oms/omsCustomerServiceTickets/saveOrUpdate`, {
          contentHtml: str
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.ordeCode = res.data
            this.isShowMask = true
          }
        })
    }
  },
  beforeDestroy () {
    window.onreset = () => {}
  },
  beforeCreate () {
    console.log('beforeCreate')
    window.onresize = jumpLink
    jumpLink()
    function jumpLink () {
      const w = window.screen.width
      const minWidth = 900
      if (w < minWidth) {
        const host = window.location.host
        if (host.includes('10.10.56') || host.includes('localhost')) {
          window.location.href =
            window.location.protocol +
            '//' +
            window.location.hostname +
            ':5000/#/pages/feedback/index'
        } else if (host.includes('predev')) {
          window.location.href =
            'http://predevm.plantmate.supcon.com:8888/#/pages/feedback/index'
        } else if (host.includes('pretest')) {
          window.location.href =
            'http://pretestm.plantmate.supcon.com:8888/#/pages/feedback/index'
        } else if (host.includes('uat2')) {
          window.location.href =
            'https://uat2m-plantmate.supcon.com:8888/#/pages/feedback/index'
        } else {
          window.location.href =
            'https://m.plantmate.com/#/pages/feedback/index'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.feedback {
  font-family: Alibaba PuHuiTi;
  background-image: url("https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/shopping/feedback/feedback_bg.png");
  background-size: 100% auto;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  min-height: 100vh;
  .top_img {
    width: 654px;
    height: 654px;
    position: absolute;
    top: -30px;
  }
  .title {
    font-size: 32px;
    color: #0080ff;
    margin: 0;
    margin-bottom: 16px;
    text-align: center;
    letter-spacing: 0em;
    font-weight: normal;
  }
  .content {
    width: 780px;
    border-radius: 20px;
    background: #ffffff;
    box-shadow: 0px 4px 24px 0px rgba(0, 50, 104, 0.13);
    // position: relative;
    margin-top: 280px;
    padding: 32px;
    z-index: 10;
    margin-bottom: 32px;
    ::v-deep .el-form-item .el-form-item__label {
      color: rgba(0, 42, 111, 0.6);
      font-size: 16px;
    }
    ::v-deep .el-button--primary.is-plain {
      border-radius: 8px;
      background-color: rgba(40, 122, 254, 0.05);
      border-color: #287afe;
      color: #287afe;
      &:hover {
        background-color: #287afe;
        color: #fff;
      }
    }
    ::v-deep .el-button--primary {
      border-radius: 8px;
      background-color: #287afe;
      border-color: #287afe;
    }
    ::v-deep textarea {
      border-radius: 6px;
      background: rgba(40, 122, 254, 0.05);
      border: 1px solid rgba(0, 42, 111, 0.02);
      &::placeholder {
        font-family: Alibaba PuHuiTi;
        font-size: 16px;
        letter-spacing: 0em;
        color: rgba(0, 42, 111, 0.4);
      }
    }
    ::v-deep .el-input__count {
      background: none;
    }
  }
  .submitBtn {
    font-family: Alibaba PuHuiTi;
    width: 303px;
    height: 45px;
    border-radius: 24px;
    background: #287afe;
    border: none;
    font-size: 20px;
    margin-top: 16px;
    &:hover {
      opacity: 0.9;
    }
    &:active {
      opacity: 0.7;
    }
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 100;
    background: rgba(76, 76, 76, 0.16);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }
  .tip {
    width: 618px;
    height: 298px;
    border-radius: 16px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, 0);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .icon {
    color: #32dd43;
    font-size: 96px;
    margin-bottom: 32px;
  }
  .tip_text {
    text-align: center;
    width: 336px;
    font-size: 16px;
    color: rgba(0, 42, 111, 0.4);
  }
}
.flex {
  display: flex;
}
.flex-1 {
  flex: 1;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.mr-16 {
  margin-right: 16px;
}
</style>
